import { render } from "./WhatsAppBSPOnboardingView.vue?vue&type=template&id=15fd3664&scoped=true"
import script from "./WhatsAppBSPOnboardingView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBSPOnboardingView.vue?vue&type=script&lang=js"

import "./WhatsAppBSPOnboardingView.vue?vue&type=style&index=0&id=15fd3664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd3664"]])

export default __exports__